/**
 * ValoresReferenciaDisplay — Shows min–max range, unit, sex/age.
 *
 * Requirements: 3.7, 4.7
 */

import { useTranslation } from "react-i18next";
import { Info } from "lucide-react";

import type { ValorReferenciaItem } from "@/hooks/use-procesamiento";

interface ValoresReferenciaDisplayProps {
  valores: ValorReferenciaItem[];
}

export function ValoresReferenciaDisplay({ valores }: ValoresReferenciaDisplayProps) {
  const { t } = useTranslation();

  if (valores.length === 0) return null;

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-1.5 text-sm font-medium">
        <Info className="h-4 w-4 text-muted-foreground" />
        <span>{t("procesamiento.captura.valores_referencia")}</span>
      </div>
      <div className="rounded-md border bg-muted/30 p-3 space-y-2">
        {valores.map((vr) => (
          <div key={vr.id} className="flex items-center justify-between text-xs">
            <div className="flex items-center gap-2">
              <span className="text-muted-foreground">{vr.sexo_display}</span>
              {vr.rango_edad_str && (
                <span className="text-muted-foreground">({vr.rango_edad_str})</span>
              )}
            </div>
            <div className="flex items-center gap-2 font-mono">
              <span className="font-medium">{vr.rango_str}</span>
              {vr.unidad && <span className="text-muted-foreground">{vr.unidad}</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
